// Number properties calculations extracted from previous implementation

export function getFactorization(n) {
    if (n <= 1) return n.toString();
    let factors = [];
    let d = 2;
    let temp = n;
    while (d * d <= temp) {
        while ((temp % d) === 0) {
            factors.push(d);
            temp /= d;
        }
        d++;
    }
    if (temp > 1) {
        factors.push(temp);
    }
    return factors.join(' × ');
}

export function getDivisors(n) {
    let divs = [];
    for (let i = 1; i * i <= n; i++) {
        if (n % i === 0) {
            divs.push(i);
            if (i * i !== n) {
                divs.push(n / i);
            }
        }
    }
    return divs.sort((a, b) => a - b);
}

export function getDivisorCount(n) {
    return getDivisors(n).length;
}

export function getDivisorsList(n) {
    let divs = getDivisors(n);
    if (divs.length > 15) {
        return divs.slice(0, 10).join(', ') + '... ' + divs.slice(-2).join(', ');
    }
    return divs.join(', ');
}

export function getDivisorsSum(n) {
    return getDivisors(n).reduce((a, b) => a + b, 0);
}

export function isPrime(n) {
    if (n <= 1) return false;
    if (n <= 3) return true;
    if (n % 2 === 0 || n % 3 === 0) return false;
    for (let i = 5; i * i <= n; i += 6) {
        if (n % i === 0 || n % (i + 2) === 0) return false;
    }
    return true;
}

export function getOrdinalSuffix(i) {
    let j = i % 10, k = i % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
}

export function getNumberTypeInfo(n) {
    if (n === 1) return { count: 1, type: 'Unit' };
    if (isPrime(n)) {
        let count = 0;
        for (let i = 2; i <= n; i++) {
            if (isPrime(i)) count++;
        }
        return { count, type: 'Prime #' };
    } else {
        let count = 0;
        for (let i = 4; i <= n; i++) {
            if (!isPrime(i)) count++;
        }
        return { count, type: 'Composite #' };
    }
}

// Nth sequence functions
export function nthPrime(n) {
    if (n > 100000) return "Number too large";
    let count = 0;
    let num = 1;
    while (count < n) {
        num++;
        if (isPrime(num)) count++;
    }
    return num;
}

export function nthComposite(n) {
    if (n > 100000) return "Number too large";
    let count = 0;
    let num = 3;
    while (count < n) {
        num++;
        if (!isPrime(num)) count++;
    }
    return num;
}

export function nthFibonacci(n) {
    if (n > 100000) return "Number too large";
    if (n === 1 || n === 2) return 1;
    let a = 1n, b = 1n, c = 0n;
    for (let i = 3; i <= n; i++) {
        c = a + b;
        a = b;
        b = c;
    }
    let res = b.toString();
    if (res.length > 20) return res.substring(0, 10) + '... (' + res.length + ' digits)';
    return res;
}

export function nthTriangular(n) {
    let bigN = BigInt(n);
    return (bigN * (bigN + 1n) / 2n).toString();
}

export function nthSquare(n) {
    let bigN = BigInt(n);
    return (bigN * bigN).toString();
}

export function nthCube(n) {
    let bigN = BigInt(n);
    return (bigN * bigN * bigN).toString();
}

export function nthTetrahedral(n) {
    let bigN = BigInt(n);
    return (bigN * (bigN + 1n) * (bigN + 2n) / 6n).toString();
}

export function nthSquarePyramidal(n) {
    let bigN = BigInt(n);
    return (bigN * (bigN + 1n) * (2n * bigN + 1n) / 6n).toString();
}

export function nthStar(n) {
    let bigN = BigInt(n);
    return (6n * bigN * (bigN - 1n) + 1n).toString();
}

export function nthPentagonal(n) {
    let bigN = BigInt(n);
    return (bigN * (3n * bigN - 1n) / 2n).toString();
}

export function parseBase(val, base) {
    let str = val.toString();
    let valid = true;
    for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i);
        let digitVal = 0;
        if (charCode >= 48 && charCode <= 57) digitVal = charCode - 48; // 0-9
        else if (charCode >= 97 && charCode <= 122) digitVal = charCode - 97 + 10; // a-z
        else if (charCode >= 65 && charCode <= 90) digitVal = charCode - 65 + 10; // A-Z
        else valid = false;

        if (digitVal >= base) valid = false;
    }
    if (!valid) return '-';
    return parseInt(str, base);
}
